import React from "react";
import { PrismicRichText } from "@prismicio/react";
import { Content } from "@prismicio/client";
import { RichTextField } from "@prismicio/types";
import style from "./ReferralModal.module.scss";
import { TitlePage } from "../../TitlePage/TitlePage";

interface Props {
  modalContent?:
    | Content.ReferralPopupDocument
    | Content.ReferralPopupStagingDocument;
}
export default function Benefits({ modalContent }: Props) {
  const getTitle = (field?: RichTextField) => (
    <TitlePage className={style.benefitTitle}>
      <PrismicRichText field={field} />
    </TitlePage>
  );
  const getBenefit = (field?: RichTextField) => (
    <div className={style.benefit}>
      <PrismicRichText field={field} />
    </div>
  );

  return (
    <div className={style.benefits}>
      <div className="">
        {getTitle(modalContent?.data.InviterBenefitTitle)}
        {getBenefit(modalContent?.data.inviterReward)}
      </div>
      <div className={style.separater}></div>
      <div className="">
        {getTitle(modalContent?.data.inviteeBenefitTitle)}
        {getBenefit(modalContent?.data.inviteeReward)}
      </div>
    </div>
  );
}
